import React, { FC } from 'react';
import styled from 'styled-components';

import SecureInput, { ISecureInputProps } from '@ui/atoms/SecureInput';

import { IStyledTextInputProps } from '@ui/forms/TextInput';

interface IPasswordInputProps extends ISecureInputProps {}

const PasswordInput: FC<IPasswordInputProps & IStyledTextInputProps> = (textProps) => {
	const masker = (val: string) => val;
	const changeHandler = (value: string): string => value;

	return (
		<SecureInput
			isPassword
			masker={masker}
			changeHandler={changeHandler}
			inputType="password"
			{...textProps}
		/>
	);
};

export default styled(PasswordInput)``;
